<div class="container-fluid m-0 p-2">
    
  <div class="card-body p-0 m-0 shadow">
    <div class="row d-flex m-0 p-0">
      <div class="col-md-6 my-auto">
        <div class="custom-search my-auto p-2">
          <input type="text" class="custom-search-input"  placeholder="Search for">
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <div class="type-2">
          <input #file type="file" accept="image/*" (change)="onFileChange($event)" style="display: none;" multiple="false" accept=".xlsx, .xls, .csv">
          <div class="text-center">
            <a class="btn btn-1 m-2" (click)="file.click()">
              <span class="txt">Browse</span>
              <span class="round"><i class="fa fa-file-excel-o fa-lg"></i></span>
            </a>
          </div> 
        </div>
        <div class="type-3">
          <div class="text-center">
            <a class="btn btn-1 m-2">
              <span class="txt">Upload</span>
              <span class="round"><i class="fa fa-upload fa-lg"></i></span>
            </a>
          </div> 
        </div> 
      </div> 
    </div>
    <div class="upload">
      <div class="table-responsive p-2">
        <table class="table box-table table-borderless m-0 p-0">
            <thead class="">
                <tr class="justify-content-center">
                      <th class="text-center"><p class="m-0">S.NO</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">STATE</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">SHOWROOM</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">FLOOR</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">LOCATION</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">TYPE</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">CREATIVE</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">VENDOR</p></th>
                      <th class="" mat-sort-header = ""><p class="m-0">PARTICULARS</p></th>
                      <th class="" mat-sort-header = ""><p class="m-0">COST</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">HOARDING NAME</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">SIZE</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">IMAGE</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">INSTALLATION DATE</p></th>
                      <th class="text-center" mat-sort-header = ""><p class="m-0">EXPIRY DATE</p></th>
                    </tr>
                
                </thead>

                <tbody class="">
                  <tr class="" *ngFor="let data of importCampaign| slice: (page-1) * pageSize : page * pageSize;let i=index">
                    <td class="text-center"><p class="m-0 p-0">{{i+1}}</p></td>
                    <td class="text-center"><p class="m-0 p-0">{{data.region}}</p></td>

                    <td class="text-center">
                        <p class="m-0">{{data.showroom}}</p>
                    </td>
                    <td class="text-center">
                        <p class="m-0">{{data.floor}}</p>
                    </td>
                
                    <td class="text-center"><p class="m-0">{{data.location}}</p></td>
                    <td class="text-center"><p class="m-0">{{data.assets_type}}</p></td>
                    <td class="text-center"><p class="m-0">{{data.creative}}</p></td>
                    <td class="text-center"><p class="m-0">{{data.vendor}}</p></td>
                    <td class=""><p class="m-0">{{data.particulars}}</p></td>
                    <td class=""><p class="m-0">{{data.cost}}</p></td>
                    <td class="text-center"><p class="m-0">{{data.name}}</p></td>
                    <td class="text-center">
                        W {{data.width}}" x H{{data.height}}"
                    </td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                </tr>
                </tbody> 
            </table>
        </div>
        <div class="mt-3 sl-pagination text-center justify-content-center">
            <ngb-pagination  [(page)]="page"  [maxSize]="5"
            [pageSize]="pageSize"  *ngIf="importCampaign.length > 10"  [maxSize]="5"
            [collectionSize]="importCampaign.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
        </div>
       
    </div>
    </div>
  </div>    
